import Toggle from "PFComponents/toggle/toggle";

import { ComponentProps } from "../component_prop_types";

type ToggleWrapperProps = Pick<
  ComponentProps,
  "property" | "label" | "error" | "required" | "disabled" | "tabIndex" | "style" | "inputRef"
> & {
  value: boolean;
  onChange: (newValue: boolean) => void;
  qaId: string;
  variant?: "default" | "table";
};

export const ToggleWrapper = ({
  property,
  label,
  onChange,
  error,
  value,
  qaId,
  required,
  disabled,
  variant,
  tabIndex,
  style,
  inputRef
}: ToggleWrapperProps) => (
  <Toggle
    switchRef={inputRef}
    onChange={onChange}
    error={error}
    label={label}
    labelIcons={property?.description ? [{ text: property.description, icon: "info" }] : []}
    checked={!!value}
    qaId={qaId}
    required={required}
    disabled={disabled}
    variant={variant}
    tabIndex={tabIndex}
    style={style}
  />
);
